module.exports = __webpack_public_path__ + "static/img/android7.4e79418d.jpg";